import { render, staticRenderFns } from "./PollList.vue?vue&type=template&id=e437587a&scoped=true"
import script from "./PollList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PollList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PollList.vue?vue&type=style&index=0&id=e437587a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e437587a",
  null
  
)

export default component.exports